/* eslint-disable class-methods-use-this */
import { CancelToken } from 'axios';
import { EntityDto } from '../dto/entityDto';
import { PagedResultDto } from '../dto/pagedResultDto';
import http from '../httpService';
import { CreateUpdateServiceTemplate, PagedServiceTemplateRequest, ServiceTemplate } from './dto/serviceTemplate';

class ServiceTemplateService {
  public async getAll(
    request: PagedServiceTemplateRequest,
    cancelToken?: CancelToken
  ): Promise<PagedResultDto<ServiceTemplate>> {
    const result = await http.get('api/services/app/ServiceTemplate/GetAll', {
      params: request,
      cancelToken,
    });
    return result.data.result;
  }

  public async get(entityDto: EntityDto<number>): Promise<ServiceTemplate> {
    const result = await http.get('api/services/app/ServiceTemplate/Get', { params: entityDto });
    return result.data.result;
  }

  public async create(template: CreateUpdateServiceTemplate): Promise<ServiceTemplate> {
    const result = await http.post('api/services/app/ServiceTemplate/Create', template);
    return result.data.result;
  }

  public async update(template: CreateUpdateServiceTemplate): Promise<ServiceTemplate> {
    const result = await http.put('api/services/app/ServiceTemplate/Update', template);
    return result.data.result;
  }

  public async delete(entityDto: EntityDto<number>): Promise<void> {
    await http.delete('api/services/app/ServiceTemplate/Delete', { params: entityDto });
  }

  /**
   * Replaces the templates one service belongs to - My Services direction.
   * POST, not PUT: ABP's dynamic API maps a "Set" prefix to the default verb.
   * The opposite direction goes through update(), which already replaces a template's services.
   */
  public async setServiceTemplates(
    serviceId: number,
    serviceTemplateIds: number[]
  ): Promise<ServiceTemplate[]> {
    const result = await http.post('api/services/app/ServiceTemplate/SetServiceTemplates', {
      serviceId,
      serviceTemplateIds,
    });
    return result.data.result;
  }

  public async getByService(serviceId: number): Promise<ServiceTemplate[]> {
    const result = await http.get('api/services/app/ServiceTemplate/GetByService', {
      params: { id: serviceId },
    });
    return result.data.result;
  }
}

export default new ServiceTemplateService();
